export enum CallDirectionKeys {
  inbound = 'Inbound',
  outbound = 'Outbound',
}
